/* Estado global de la simulación GPS.
   >>> PARA GPS REAL: reemplazar el setInterval por una suscripción
   >>> WebSocket/MQTT que actualice b.dist con la posición del backend. */
import { reactive } from 'vue';
import { ROUTES, saveState, loadState } from '../data/mock';

export const sim = reactive({
  tab: 'mapa',
  selected: '104',
  follow: false,
  routes: ROUTES,
  lastTick: Date.now(),

  get selectedRoute() {
    return this.routes.find(r => r.id === this.selected);
  }
});

loadState(sim.routes);

let timer = null;

export function startSim() {
  if (timer) return;
  timer = setInterval(() => {
    sim.routes.forEach(r => r.buses.forEach(b => {
      b.dist += (b.speed / 3.6) * 2 * (0.6 + Math.random() * 0.8);
      b.vel = Math.round(b.speed * (0.75 + Math.random() * 0.5));
    }));
    sim.lastTick = Date.now();
    saveState(sim.routes);
  }, 2000);
}
